import { render, staticRenderFns } from "./PartnersSmallSize.vue?vue&type=template&id=5ee542ac&"
import script from "./PartnersSmallSize.vue?vue&type=script&lang=js&"
export * from "./PartnersSmallSize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports